class RhymatologyLoop extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.rhymatology-loop__item'));
    if (this.items.length === 0) return;

    // Each item opens on click (or Enter / Space); the first is open by default
    // and one item always stays open.
    this.items.forEach((item, index) => {
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');

      item.addEventListener('click', (event) => {
        if (event.target.closest('a, button')) return;
        this.setActive(index);
      });

      item.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        this.setActive(index);
      });
    });

    this.setActive(0);
  }

  setActive(index) {
    this.items.forEach((item, i) => {
      item.toggleAttribute('active', i === index);
      item.setAttribute('aria-expanded', i === index ? 'true' : 'false');
    });

    this.activeIndex = index;
  }
}

customElements.define('rhymatology-loop', RhymatologyLoop);
